import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Injectable({ providedIn: 'root' })

export class AdminGuardService {
  constructor(private router: Router, private toastr: ToastrService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!localStorage.getItem('token') || sessionStorage.getItem('checksess') !== 'e-Fid@mlm0@AdmI') {
      this.toastr.warning('You are not allowed to view this page. You are redirected to login Page', 'Unauthorized !');
      alert('You are not allowed to view this page. You are redirected to login Page');
      this.router.navigate(['/user/sign-in']);
      return false;
    }
    return true;
  }
}
